module.exports = __webpack_public_path__ + "static/map_Login.6d275fee.png";